import { render } from "./RouterLinkComponent.vue?vue&type=template&id=a909fddc"
import script from "./RouterLinkComponent.vue?vue&type=script&lang=js"
export * from "./RouterLinkComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__